import { DownlineCache } from "Membership/LookupByIBO/Details/LOS/DownlineTree/useDownlineCache";
import React, { Suspense } from "react";
import {
  Colours as ColoursIcon,
  CreditCard as CreditCardIcon,
  Cup as CupIcon,
  Dolar as DollarIcon,
  Lock as IconLock,
  Person as PersonIcon,
} from "react-ikonate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

import { IconLOSTree } from "@wwg/icons";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { RequestCache } from "shared/@hooks/useRequestCache";
import { Auth } from "shared/@auth/Auth";
import LoadingPage from "shared/LoadingPage";
import Page, { Content, Nav, NavGroup, NavItem } from "shared/Page";
import AmwayLookup from "./AmwayLookup";
import Billing from "./Billing";
import LOAPlugins from "./LOAPlugins";
import LookupByIBO from "./LookupByIBO";
import LookupByPinLevel from "./LookupByPinLevel";
import LookupByEmail from "./LookUpByEmail";

export default function Membership() {
  const { path } = useRouteMatch();
  const { hasPermission } = Auth.useContainer();

  return (
    <RequestCache.Provider>
      <DownlineCache.Provider>
        <Page>
          <Nav>
            <NavGroup title="Lookup">
              <NavItem to={`${path}/lookup/ibo`} icon={<PersonIcon />}>
                By IBO
              </NavItem>
              <NavItem
                to={`${path}/lookup/email`}
                icon={<FontAwesomeIcon icon={faEnvelope} />}
              >
                By Email
              </NavItem>
              <NavItem to={`${path}/lookup/pin`} icon={<IconLOSTree />}>
                By Pin Level
              </NavItem>
              <NavItem to={`${path}/lookup/amway`} icon={<CupIcon />}>
                Amway Lookup
              </NavItem>
            </NavGroup>

            {hasPermission("developer.*") && (
              <NavGroup title="Financial">
                <NavItem
                  to={`${path}/financial/loa-plugins`}
                  icon={<ColoursIcon />}
                >
                  LOA Plugins
                </NavItem>

                <NavItem
                  to={`${path}/financial/billing`}
                  icon={<CreditCardIcon />}
                >
                  Billing
                </NavItem>

                <NavItem
                  to={`${path}/financial/commissions`}
                  icon={<DollarIcon />}
                >
                  Commissions
                </NavItem>
              </NavGroup>
            )}

          </Nav>
          <Content>
            <Suspense fallback={<LoadingPage />}>
              <Switch>
                <Route path={`${path}/lookup/ibo/:iboNumber?`}>
                  <LookupByIBO />
                </Route>

                <Route path={`${path}/lookup/pin`}>
                  <LookupByPinLevel />
                </Route>

                <Route path={`${path}/lookup/email`}>
                  <LookupByEmail />
                </Route>

                <Route path={`${path}/lookup/amway`}>
                  <AmwayLookup />
                </Route>

                <Route path={`${path}/financial/loa-plugins`}>
                  <LOAPlugins />
                </Route>

                <Route path={`${path}/financial/billing`}>
                  <Billing />
                </Route>

                <Route path={`${path}/financial/commissions`}>
                  Commissions
                </Route>

                <Route path="*">
                  <Redirect to={`${path}/lookup/ibo`} />
                </Route>
              </Switch>
            </Suspense>
          </Content>
        </Page>
      </DownlineCache.Provider>
    </RequestCache.Provider>
  );
}
